import { render, staticRenderFns } from "./currency-exchange-rate.vue?vue&type=template&id=3afba972&scoped=true&"
import script from "./currency-exchange-rate.vue?vue&type=script&lang=js&"
export * from "./currency-exchange-rate.vue?vue&type=script&lang=js&"
import style0 from "./currency-exchange-rate.vue?vue&type=style&index=0&id=3afba972&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afba972",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3afba972')) {
      api.createRecord('3afba972', component.options)
    } else {
      api.reload('3afba972', component.options)
    }
    module.hot.accept("./currency-exchange-rate.vue?vue&type=template&id=3afba972&scoped=true&", function () {
      api.rerender('3afba972', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sms-channel-management/currency-exchange-rate.vue"
export default component.exports